import React from 'react';
import StatusBadge from '../shared/StatusBadge';
import './VoiceComplianceCards.css';

const StirShakenCard = ({ stirShakenData, disabled = false }) => {
  const hasStirShaken = stirShakenData && stirShakenData.id && stirShakenData.status;

  const getStatusBadge = (status) => {
    const statusMap = {
      'draft': { badge: 'draft', label: 'Draft' },
      'pending-review': { badge: 'pending', label: 'Pending Review' },
      'twilio-approved': { badge: 'approved', label: 'Approved' },
      'approved': { badge: 'approved', label: 'Approved' },
      'twilio-rejected': { badge: 'rejected', label: 'Rejected' },
    };
    return statusMap[status] || { badge: 'draft', label: status };
  };

  const getHeaderColorClass = (status) => {
    const normalizedStatus = status ? status.toLowerCase() : '';
    if (['twilio-approved', 'approved'].includes(normalizedStatus)) return 'card-header--approved';
    if (['pending-review'].includes(normalizedStatus)) return 'card-header--pending';
    if (['twilio-rejected', 'rejected'].includes(normalizedStatus)) return 'card-header--rejected';
    if (['draft'].includes(normalizedStatus)) return 'card-header--draft';
    return 'card-header--default';
  };

  return (
    <div className={`voice-compliance-card ${disabled ? 'voice-compliance-card--disabled' : ''}`} id="StirShakenCard">
      {/* Header with Icon and Title */}
      <div className={`card-header ${hasStirShaken ? getHeaderColorClass(stirShakenData.status) : ''}`}>
        <div className="card-icon-title">
          <i className="la la-shield-alt" style={{ fontSize: '20px' }}></i>
          <h3 className="card-title">SHAKEN/STIR Attestation</h3>
        </div>
        {hasStirShaken && (
          <span className="status-text">{getStatusBadge(stirShakenData.status).label}</span>
        )}
      </div>

      {/* Status Messages */}
      {disabled ? (
        <div className="status-message status-message-warning">
          <p>⚠️ Complete Business Profile first to enable STIR/SHAKEN</p>
        </div>
      ) : hasStirShaken ? (
        <>
          {['twilio-approved', 'approved', 'verified'].includes(stirShakenData.status) && (
            <div className="status-message status-message-success">
              <p>STIR/SHAKEN attestation is active - auto-configured from business profile</p>
            </div>
          )}

          {stirShakenData.status === 'pending-review' && (
            <div className="status-message status-message-warning">
              <p>Auto-configuration in progress (typically 24-48 hours)</p>
            </div>
          )}

          {stirShakenData.status === 'twilio-rejected' && (
            <div className="status-message status-message-error">
              <p>Auto-configuration failed. Contact support.</p>
            </div>
          )}

          {stirShakenData.status === 'draft' && (
            <div className="status-message status-message-warning">
              <p>Configuration in progress</p>
            </div>
          )}
        </>
      ) : (
        <div className="status-message status-message-info">
          <p>Automatically triggered when business profile is approved</p>
        </div>
      )}
    </div>
  );
};

export default StirShakenCard;
